import React, { Component, Fragment } from 'react'
import moment from 'moment'
import { Query } from 'react-apollo'

import Hero from '../../components/Hero'
import Breadcrumb from '../../components/Breadcrumb'
import Loader from '../../components/Loader'
import Error from '../../components/Error'
import SearchInput from '../../components/SearchInput'
import DocumentTable from '../../components/DocumentTable'
import EmployeeCTA from '../../components/EmployeeCTA'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { SELF_QUERY } from '../../queries'

import { Container } from '../../styles/defaults'
import { PageTitle, SearchContainer, InfoContainer, CompanyInfo, MiniContainer } from './styles'

import hero from '../../assets/hero/bestellijst/bestellijst.jpg'
import employee from '../../assets/cta/employee.png'

class Documents extends Component {
  constructor(props) {
    super(props)
    this.state = {
      documents: []
    }
  }

  componentDidMount() {
    const { documents } = this.props
    const formatted = documents ? documents.filter((document) => document.type === 'Opdrachtnummer') : []
    this.setState({ documents: formatted })
  }

  // Sort documents based on date
  onSearch(e) {
    let query = e.target.value.trim().toLowerCase()
    let queryLength = e.target.value.length
    this.setState({ query: e.target.value })
    this.setState({
      documents: this.props.documents
        .filter(document => {
          let documentDate = moment(document.documentDate).format('DD-MM-YYYY')
          let documentNumber = document.documentNumber
            .toString()
            .toLowerCase()
            .slice(0, queryLength)

          return (
            documentDate.includes(query) || documentNumber === query
          )
        })
        .sort((a, b) => new Date(b.documentDate) - new Date(a.documentDate))
    })
  }

  formatDocuments(documents) {
    const items = []
    documents.map(document => {
      return items.push({
        id: document.id,
        one: document.documentNumber,
        two: moment(document.documentDate).format('DD-MM-YYYY'),
        three: document.documentName,
        four: document.documentName
      })
    })

    return items
  }

  render() {
    const { documents } = this.state
    const headers = ['Documentnummer', 'Datum', 'Documentnaam', 'Bijlagen']
    const formattedDocuments = this.formatDocuments(documents)
    return (
      <Fragment>
        <Hero setsize='small' small={hero} medium={hero} large={hero} retina={hero} title='Technische gegevens' />
        <Breadcrumb title='Technische gegevens' />
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from='25%' to='45%' fixed />
            if (error) return <Error error='de gebruikersgegevens' />
            const { self } = data
            let viewDocs = self.permissions.includes('VIEW_TECH') || self.role === 'MANAGER'

            return (
              <Fragment>
                {viewDocs ? (
                  <Fragment>
                    <Container mt>
                      <PageTitle>Werkbonnen</PageTitle>
                    </Container>
                    <InfoContainer full>
                      <CompanyInfo>{documents.length} werkbonnen</CompanyInfo>
                      <SearchContainer>
                        <SearchInput placeholder='Zoeken' onSearch={this.onSearch.bind(this)} />
                      </SearchContainer>
                    </InfoContainer>
                    <Container mt mb>
                      {documents.length > 0 ? (
                        <Fragment>
                          <DocumentTable
                            headers={headers}
                            items={formattedDocuments}
                            data={data}
                            loading={loading}
                            error={error}
                          />
                          <MiniContainer full>
                            <EmployeeCTA
                              size={'medium'}
                              content={{
                                title: 'Vragen over een werkbon?',
                                subtitle: 'We helpen u graag',
                                employee: true,
                                image: employee,
                                link: {
                                  content: 'Contact',
                                  url: '/contact',
                                  target: ''
                                }
                              }}
                            />
                          </MiniContainer>
                        </Fragment>
                      ) : (
                        <Fragment>Er zijn geen werkbonnen beschikbaar</Fragment>
                      )}
                    </Container>
                  </Fragment>
                ) : (
                  <Container mt mb>
                    Onvoldoende rechten om de werkbonnen te bekijken
                  </Container>
                )}
              </Fragment>
            )
          }}
        </Query>
      </Fragment>
    )
  }
}

export default withHeaderFooter(Documents)



// WEBPACK FOOTER //
// ./src/views/Documents/index.js